export default {
  init() {

    $('[data-container-link]').on('click', function () {
      window.location = $(this).find('a').attr('href');
    })

    $('.menu-item-has-children>a').on('click', (e) => {
      e.preventDefault();
    })

    let $allLabels = $('label.wpforms-field-label-inline');
    let allFittingLabels = $allLabels.filter(function () {
      return ($(this).text().toLowerCase() == 'verstanden');
    })
    let allContainers = allFittingLabels.map(function () {
      return $(this).parents('.wpforms-field.wpforms-field-checkbox');
    })

    /* eslint-disable */
    allContainers.each(function () {
      $(this).find('label').each(function () {
        let label = $(this);
        let theText = label.html();
        if (theText.indexOf(':') != -1) {
          label.css('font-weight', '300');
          const regex = /(.*?:)(.*)/gm;
          const subst = "<strong>$1</strong><br><br>$2"; 	/* eslint-disable */
          label.html(theText.replace(regex, subst));
        }
      });
    });

  }
  ,
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  }
  ,
}
;



// WEBPACK FOOTER //
// ./scripts/routes/common.js